import { useQuery } from '@tanstack/react-query'
import { Employer, employersQuery } from '../features/employers'

export const useEmployers = (initialData?: Employer[]) => useQuery(
  {
    ...employersQuery(),
    initialData: initialData ?? undefined
  }
)
